import React, { Fragment, useState } from "react";
import {
  List,
  ListItem,
  Collapse,
  Drawer,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

const menus = [
  {
    id: 1,
    title: "Homepage",
    link: "/",
  },
  {
    id: 2,
    title: "About Us",
    link: "/about",
  },
  {
    id: 3,
    title: "Services",
    link: "/service",
  },
  {
    id: 4,
    title: "Blog",
    link: "/blog",
  },
  {
    id: 5,
    title: "Contact",
    link: "/contact",
  },
];

const MobileMenu = ({ open, onClose }) => {
  const [openId, setOpenId] = useState(0);

  const ClickHandler = (link) => {
    window.scrollTo(10, 0);
    onClose(); // Close drawer when menu item is clicked
  };

  const handleSubmenuToggle = (id) => {
    setOpenId(openId === id ? 0 : id);
  };

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: 280,
          boxSizing: "border-box",
        },
      }}
    >
      <Box sx={{ width: 280 }}>
        {/* Header with close button */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Typography variant="h6" component="div">
            Menu
          </Typography>
          <IconButton onClick={onClose}>
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>×</span>
          </IconButton>
        </Box>

        {/* Menu Items */}
        <List>
          {menus.map((item) => (
            <Fragment key={item.id}>
              {item.submenu ? (
                // Menu item with submenu
                <>
                  <ListItem button onClick={() => handleSubmenuToggle(item.id)}>
                    <span style={{ flex: 1 }}>{item.title}</span>
                    <span style={{ fontSize: "12px" }}>
                      {openId === item.id ? "▲" : "▼"}
                    </span>
                  </ListItem>
                  <Collapse
                    in={openId === item.id}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      {item.submenu.map((submenu) => (
                        <ListItem
                          button
                          key={submenu.id}
                          sx={{ pl: 4 }}
                          component={Link}
                          to={submenu.link}
                          onClick={() => ClickHandler(submenu.link)}
                        >
                          <span>{submenu.title}</span>
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </>
              ) : (
                // Simple menu item
                <ListItem
                  button
                  component={Link}
                  to={item.link}
                  onClick={() => ClickHandler(item.link)}
                  sx={{
                    "&:hover": {
                      backgroundColor: "rgba(0,0,0,0.04)",
                    },
                  }}
                >
                  <span>{item.title}</span>
                </ListItem>
              )}
            </Fragment>
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default MobileMenu;
